import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import Astron from '../icons/Astron';
import MundAstron from '../icons/MundAstron';

export default function AstronMembers() {
  return (
    <IntegrationTable
      integrationKey='astron_members'
      title='Astron Members'
      main_icon={<MundAstron />}
      icon={<Astron />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
    />
  );
}
